module.exports = __webpack_public_path__ + "media/warning.443d0f82.ogg";